import { Chip } from 'components';
import { Participation } from '@app/api';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  reasonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
  },
}));

interface Props {
  participation: Participation;
}

export const TableDeclinedReasonList = ({ participation }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  if (!participation.declinedReason) {
    return null;
  }

  return (
    <div className={classes.reasonContainer}>
      <Chip color="red" overGray>
        {t(
          `sessions.details.participationsDetails.declinedReason.${participation.declinedReason}`,
        )}
      </Chip>
    </div>
  );
};
